import React, { Component } from "react";
import { getRandomInt } from "../Utils/Utils";
import { sourceStyle, newsStyle, newsBlockStyle } from "../Styles/Styles";
import ReactGA from "react-ga";
import axios from "axios";
import "./RandomGoodNews.css";
ReactGA.initialize('UA-167324374-1');

interface RandomGoodNewsProps {
  updateBackgroundColor: () => void;
}
interface RandomGoodNewsState {
  news: string;
  source: string;
  link: string;
}

export class RandomGoodNews extends Component<
  RandomGoodNewsProps,
  RandomGoodNewsState
> {
  constructor(props: RandomGoodNewsProps) {
    super(props);
    this.state = {
      news: "",
      source: "",
      link: ""
    };
  }

  componentDidMount() {
    this.getGoodNews();
  }

  updateGoodNews() {
    this.getGoodNews();
    ReactGA.event({
      category: "Refresh",
      action: "Refreshed news",
    });
  }

  private getGoodNews() {
    let url =
      "https://gist.githubusercontent.com/Loubnar/2ee121c6e301e78ba6e200a4d6132404/raw/covid19goodnews.json";
    axios.get(url).then((res) => {
      let data = res.data.goodnews;
      let selectedItem = data[getRandomInt(data.length)];

      this.setState({
        news: selectedItem.news,
        source: selectedItem.source,
        link: selectedItem.link
      });

      this.props.updateBackgroundColor();
    });
  }

  render() {
    const { news, source, link } = this.state;
    return (
      <>
        <div className="NewsBlock" style={newsBlockStyle}>
            <h2 style={newsStyle}>{news}</h2>
            <p style={sourceStyle}>Source: {<a href={link} target="_blank" rel="noopener noreferrer">{source}</a>}</p>
        </div>
        <div className="RefreshButton">
          <img
            src={require("../Assets/refresh.png")}
            alt="Refresh"
            style={{ width: 20 }}
            onClick={() => this.updateGoodNews()}
          />
        </div>
      </>
    );
  }
}
